import styled from 'styled-components'

export const Wrapper = styled.div<{ linkCopied: boolean }>`
  background: ${({ linkCopied }) => (linkCopied ? 'var(--grey-25)' : 'transparent')};
  cursor: pointer;
  border-radius: 100%;
  height: 48px;
  width: 48px;
  transition: all 300ms ease-in-out;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: var(--grey-25);
    transform: scale(0.98);
  }

  &:active {
    transform: scale(0.85);
  }
`
